import React, { Component, Fragment } from "react"
import "../../../assets/js/dashboard.js"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { ToggleChange } from "../../../redux/action/Header"
import { withRouter } from "react-router-dom"
import { confirmAlert } from "react-confirm-alert"

class Sidebar extends Component {
    state = {
        isOpen: false,
        status: 1,
        toggle: {
            development: false,
            fabric: false,
            system: false,
            employee: false,
            new: false
        },
        rights: {},
        PageLeave: false,
        reportRights: false
    }

    addClass = e => {
        var toggleClass = document.getElementById("toggle-nav-bar")
        toggleClass.classList.add("class-nav-bar")
        this.props.ToggleChange(true)
    }

    removeClass = e => {
        setTimeout(() => {
            var toggleClass = document.getElementById("toggle-nav-bar")
            toggleClass.classList.remove("class-nav-bar")
            let toggle = { ...this.state.toggle }
            Object.keys(toggle).forEach(keyName => (toggle[keyName] = false))
            this.setState({
                toggle
            })

            this.props.ToggleChange(false)
        }, 500)

    }

    selected = (e, pathVal) => {
        var el = document.getElementById(pathVal)
        if (
            pathVal !== "development" ||
            pathVal !== "style" ||
            pathVal !== "system" ||
            pathVal !== "permission"
        ) {
            this.props.history.push(pathVal)
        }
    }

    setQueryString = modulename => {
        this.props.history.push({
            pathname: "/system",
            search: modulename
        })
    }

    toggleOpen = moduleName => {
        let toggle = { ...this.state.toggle }
        toggle[moduleName] = !this.state.toggle[moduleName]
        this.setState({ toggle })
        
    }

    confirmLeavePage = obj => {
        const { pathname } = this.props.location
        const pathNameList = ['/CostingPage', '/StylePage', '/Sample', '/MeetingNote', '/developmentCad', 'developmentFabric', '/Trim', '/BNumber', '/bulkImport', '/printFabricNumber', '/SmvThread', '/technicalIssues', '/printStyleNumber', '/CustomerPage', '/employee', '/permissionRole', '/Report']
        if (pathNameList.includes(pathname)) {
            // console.log("CLICKED")
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className=" p-5 text-center">
                            <h3>Are you sure?</h3>
                            <p>You want to Leave this page?</p>
                            <button type="button" class="primary" style={{ width: "20%" }} onClick={onClose}>
                                No
                            </button>{" "}
                            <button
                                type="button"
                                class="primary"
                                style={{ width: "20%" }}
                                onClick={() => {
                                    this.setState({
                                        PageLeave: true
                                    })
                                    obj.nextAction()
                                    onClose()
                                }}
                            >
                                Yes
                            </button>
                        </div>
                    )
                },
                closeOnClickOutside: true
            })
        } else {
            // `${nextAction()}`
            obj.nextAction()
        }
    }


    componentDidMount() {
        let { location, rights } = this.props
        let r = { ...rights.reports }
        let reportRights = Object.keys(r).reduce((a, x) => {
            if ((r[x].web && r[x]['web'].create) || (r[x].web && r[x]['web'].edit) || (r[x].web && r[x]['web'].view) || (r[x].web && r[x]['web'].delete)) {
                a = true
            }
            return a
        }, false)
        this.setState({
            reportRights
        })
    }

    render() {
        const { toggle, rights, reportRights } = this.state;
        return (
            <Fragment>
                <div
                    className="left-section"
                    id="left-sec-id"
                    onMouseOver={e => this.addClass(e)}
                    onMouseLeave={e => this.removeClass(e)}
                >
                    <div className="nav">
                        <ul className="left-nav" id="sideBar">
                            {this.props.rights.dashboard.web.view && (
                                <li>
                                    <a
                                        role="button"
                                        id="dashboard"
                                        onClick={e => {
                                            this.confirmLeavePage({
                                                nextAction: () => {
                                                    this.selected(e, "", this.props.history.push("/"))
                                                }
                                            })
                                            //     if(this.state.costingPageLeave) {
                                            //         console.log('PATH')
                                            //     this.selected(e, "", this.props.history.push("/"))
                                            // }
                                        }}
                                        className="changeselecteds"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div></div>
                                        <i className="icon-home icons"></i> Dashboard{" "}
                                    </a>
                                </li>
                            )}

                            {/* New start*/}

                            {/* {((this.props.rights.sampleRequest.sampleRequest && this.props.rights.sampleRequest.sampleRequest.web.view) || (this.props.rights.sampleRequest.sampleTag && this.props.rights.sampleRequest.sampleTag.web.view)) && ( */}
                            {this.props.rights.dashboardss &&
                            ((this.props.rights.dashboardss.newemployee && this.props.rights.dashboardss.newemployee.web.view) || (this.props.rights.dashboardss.newemployee && this.props.rights.dashboardss.newemployee.web.view)) && (
                                <li>
                                    <a className="changeselecteds"
                                        id="listSample"
                                        // className="fabric_dev"
                                        role="button"
                                        onClick={e => {
                                            this.toggleOpen("new")
                                        }}
                                    >
                                        <div></div> <i className="fa fa-bell"></i> New{" "}
                                    </a>
                                </li>
                            )}

                            {toggle.new && (
                                <ul className="fabric-sub-nav">
                                    {/* {this.props.rights.sampleRequest.sampleTag.web.view && ( */}
                                    {this.props.rights.dashboardss.newemployee.web.view && (
                                        <li>
                                            <a
                                                role="button"
                                                id="newdashboard"
                                                onClick={(e) => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.selected(e, "newdashboard")
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Dashboard
                                            </a>
                                        </li>
                                    )}
                                    {/* {this.props.rights.sampleRequest.sampleTag.web.view && ( */}
                                    {this.props.rights.dashboardss.newemployee.web.view && (
                                        <li>
                                            <a
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "NEWSAMPLEREQUEST",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Sample Request
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.sampleRequest.sampleRequest.web.view && (
                                    // {this.props.rights.dashboardss.newemployee.web.view && (
                                        <li>
                                            <a

                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "NEWEMPLOYEE",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div>Employee
                                            </a>
                                        </li>
                                    )}                                    
                                </ul>
                            )}

                            {/* New end*/}

                            {this.props.rights.meetingNotes.web.view && (
                                <li>
                                    <a
                                        role="button"
                                        id="listMeetingRoom"
                                        onClick={e => {
                                            this.confirmLeavePage({
                                                nextAction: () => {
                                                    this.props.history.push("/list", {
                                                        moduleName: "MEETINGROOM",
                                                        type: "list",
                                                        byValue: "",
                                                        inputSearch: ""
                                                    })
                                                }
                                            })
                                        }}
                                        className="changeselecteds"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div></div> <i className="icon-clock icons"></i> Meeting
                                        Notes{" "}
                                    </a>
                                </li>
                            )}
                            {this.props.rights.communication.web.view && (
                                <li>
                                    <a
                                        role="button"
                                        id="communication"
                                        onClick={e => {
                                            this.confirmLeavePage({
                                                nextAction: () => {
                                                    this.selected(e, "communication")
                                                }
                                            })
                                        }}
                                        className="changeselecteds"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div></div> <i className="fa fa-exchange"></i>{" "}
                                        <span class="com-rel">Communication</span>
                                    </a>
                                </li>
                            )}
                            {(this.props.rights.cad.web.view ||
                                this.props.rights.fabric.fabric.web.view ||
                                this.props.rights.bNumber.web.view ||
                                this.props.rights.bulkImport.web.view ||
                                this.props.rights.printFabricNumber.web.view ||
                                this.props.rights.trim.trim.web.view ||
                                this.props.rights.sourcing.web.view ||
                                this.props.rights.product.product.web.view) && (
                                    <li>
                                        <a
                                            role="button"
                                            id="development"
                                            className="changeselecteds"
                                            style={{ cursor: "pointer" }}
                                            onClick={e => {
                                                this.toggleOpen("development")
                                            }}
                                        >
                                            <div></div> <i className="fa fa-flag-o"></i> Development{" "}
                                        </a>
                                    </li>
                                )}

                            {toggle.development && (
                                <ul className="development-sub-nav">
                                    {this.props.rights.cad.web.view && (
                                        <li>
                                            <a
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "CAD",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                            >
                                                <div></div>CAD
                                            </a>
                                        </li>
                                    )}
                                    {(this.props.rights.fabric.fabric.web.view ||
                                        this.props.rights.bNumber.web.view ||
                                        this.props.rights.bulkImport.web.view ||
                                        this.props.rights.printFabricNumber.web.view ||
                                        this.props.rights.trim.trim.web.view ||
                                        this.props.rights.sourcing.web.view ||
                                        this.props.rights.product.product.web.view) && (
                                            <li>
                                                <a
                                                    className="fabric_dev"
                                                    role="button"
                                                    onClick={e => {
                                                        this.toggleOpen("fabric")
                                                    }}
                                                >
                                                    <div></div>Master Fabric{" "}
                                                </a>
                                            </li>
                                        )}

                                    {toggle.fabric && (
                                        <ul className="fabric-sub-nav">
                                            {this.props.rights.fabric.fabric.web.view && (
                                                <li>
                                                    <a
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            this.confirmLeavePage({
                                                                nextAction: () => {
                                                                    this.props.history.push("/list", {
                                                                        moduleName: "FABRIC",
                                                                        type: "list"
                                                                    })
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <div></div>Fabric
                                                    </a>
                                                </li>
                                            )}
                                            {this.props.rights.bNumber.web.view && (
                                                <li>
                                                    <a
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            this.confirmLeavePage({
                                                                nextAction: () => {
                                                                    this.props.history.push("/list", {
                                                                        moduleName: "BNUMBER",
                                                                        type: "list"
                                                                    })
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <div></div>B Number{" "}
                                                    </a>
                                                </li>
                                            )}
                                            {this.props.rights.bulkImport.web.view && (
                                                <li>
                                                    <a
                                                        onClick={() => {
                                                            this.confirmLeavePage({
                                                                nextAction: () => {
                                                                    this.props.history.push("/bulkImport")
                                                                }
                                                            })
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <div></div> Bulk Import{" "}
                                                    </a>
                                                </li>
                                            )}
                                            {this.props.rights.printFabricNumber.web.view && (
                                                <li>
                                                    <a
                                                        onClick={() => {
                                                            this.confirmLeavePage({
                                                                nextAction: () => {
                                                                    this.props.history.push(
                                                                        "/printFabricNumber",
                                                                        { moduleName: "Fabric" }
                                                                    )
                                                                }
                                                            })
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <div></div> PRINT FABRIC NUMBER{" "}
                                                    </a>
                                                </li>
                                            )}
                                            {/* {this.props.rights.printFabricNumber.web.view && <li><a onClick={() => this.props.history.push("/printFabricNumber", { moduleName: 'Style' })} style={{ cursor: "pointer" }}><div></div> PRINT STYLE NUMBER </a></li>} */}
                                        </ul>
                                    )}
                                    {this.props.rights.trim.trim.web.view && (
                                        <li>
                                            <a
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "TRIM",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Master Trim{" "}
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.sourcing.web.view && (
                                        <li>
                                            <a
                                                // onClick={() => {
                                                //     this.confirmLeavePage({
                                                //         nextAction: () => {
                                                //             this.props.history.push("/listSourcing", {
                                                //                 moduleName: "SOURCING",
                                                //                 type: "list"
                                                //             })
                                                //         }
                                                //     })
                                                // }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Sourcing{" "}
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.product.product.web.view && (
                                        <li>
                                            <a
                                                // onClick={() => {
                                                //     this.confirmLeavePage({
                                                //         nextAction: () => {
                                                //             this.props.history.push("/listProduct")
                                                //         }
                                                //     })
                                                // }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Product{" "}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            )}
                            {this.props.rights.style.web.view && (
                                <li>
                                    <a
                                        role="button"
                                        id="masterStyle"
                                        className="changeselecteds"
                                        style={{ cursor: "pointer" }}
                                        onClick={e => {
                                            this.toggleOpen("masterStyle")
                                        }}
                                    >
                                        <div></div> <i className="icon-star icons"></i> Style{" "}
                                    </a>
                                </li>
                            )}
                            {toggle.masterStyle && (
                                <ul className="style-sub-nav">
                                    {this.props.rights.style.web.view && (
                                        <li>
                                            <a
                                                id="listStyle"
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "STYLE",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Style List
                                            </a>
                                        </li>
                                    )}

                                    {this.props.rights.createIb.createIb.web.view && (
                                        <li>
                                            <a
                                                id="listStyle"
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "STYLE",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> IB{" "}
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.smvCalcThread.web.view && (
                                        <li>
                                            <a
                                                id="listStyle"
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "SMVTHREAD",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Smv/Ob{" "}
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.technicalIssues.web.view && (
                                        <li>
                                            <a
                                                id="listStyle"
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "TECHNICALISSUES",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Technical Issues{" "}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            )}

                            {/* sssssssssssssssssssssssssssssssssssssssssss */}
                            {((this.props.rights.sampleRequest.sampleRequest && this.props.rights.sampleRequest.sampleRequest.web.view) || (this.props.rights.sampleRequest.sampleTag && this.props.rights.sampleRequest.sampleTag.web.view)) && (
                                <li>
                                    <a className="changeselecteds"
                                        id="listSample"
                                        // className="fabric_dev"
                                        role="button"
                                        onClick={e => {
                                            this.toggleOpen("sampleRequest")
                                        }}
                                    >
                                        <div></div> <i className="fa fa-bell"></i> Sample Request{" "}
                                    </a>
                                </li>
                            )}

                            {toggle.sampleRequest && (
                                <ul className="fabric-sub-nav">
                                    {this.props.rights.sampleRequest.sampleRequest.web.view && (
                                        <li>
                                            <a

                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "SAMPLEREQUEST",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div>Sample Request
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.sampleRequest.sampleTag.web.view && (
                                        <li>
                                            <a
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/printStyleNumber", {
                                                                moduleName: "Style"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> SAMPLE TAG{" "}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            )}
                            {/* {this.props.rights.sampleRequest.sampleRequest.web.view && <li><a className="changeselecteds" id="listSample" onClick={() => {
                                this.confirmLeavePage({
                                    nextAction: () => {
                                        this.props.history.push("/list", { moduleName: 'SAMPLEREQUEST', type: 'list' })
                                    }
                                })
                            }} style={{ cursor: "pointer" }}><div></div> <i className="fa fa-bell"></i> Sample Request </a></li>} */}
                            {this.props.rights.costing.web.view && (
                                <li>
                                    <a
                                        className="changeselecteds"
                                        id="listCost"
                                        onClick={() => {
                                            this.confirmLeavePage({
                                                nextAction: () => {
                                                    this.props.history.push("/list", {
                                                        moduleName: "COSTING",
                                                        type: "list"
                                                    })
                                                }
                                            })
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div></div>
                                        <i className="fa fa-money"></i>Costing
                                    </a>
                                </li>
                            )}
                            {this.props.rights.system.web.view && (
                                <li>
                                    <a
                                        role="button"
                                        style={{ cursor: "pointer" }}
                                        className="system changeselecteds"
                                        onClick={e => {
                                            this.toggleOpen("system")
                                        }}
                                    >
                                        <div></div> <i className="fa fa-link"></i> System{" "}
                                    </a>
                                </li>
                            )}
                            {toggle.system && (
                                <ul className="system-sub-nav">
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", { type: "cad" })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> 3D{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", {
                                                            type: "costing"
                                                        })
                                                    }
                                                })
                                                // this.props.history.push("system", { type: "costing" })
                                            }}
                                        >
                                            <div></div> Costing{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", {
                                                            type: "customer"
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> Customer{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", {
                                                            type: "fabric"
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> Fabric{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", {
                                                            type: "general"
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> General{" "}
                                        </a>
                                    </li>
                                    {/* <li><a style={{ cursor: "pointer" }} onClick={() => this.props.history.push("system",{ type : "embroidery"})}><div></div> Embroidery </a></li> */}
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", {
                                                            type: "samplerequest"
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div>Sample Request
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", { type: "style" })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> Style{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("/list", {
                                                            moduleName: "SYSTEMSUPPLIER",
                                                            type: "list"
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> Suppliers{" "}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.confirmLeavePage({
                                                    nextAction: () => {
                                                        this.props.history.push("system", { type: "trims" })
                                                    }
                                                })
                                            }}
                                        >
                                            <div></div> Trims{" "}
                                        </a>
                                    </li>
                                </ul>
                            )}
                            {(this.props.rights &&
                            this.props.rights.customer &&
                            this.props.rights.customer.customer &&
                            this.props.rights.customer.customer.web &&
                            this.props.rights.customer.customer.web.view)  && (
                                <li>
                                    <a
                                        className="changeselecteds"
                                        onClick={() => {
                                            this.confirmLeavePage({
                                                nextAction: () => {
                                                    this.props.history.push("/list", {
                                                        moduleName: "CUSTOMER",
                                                        type: "list"
                                                    })
                                                }
                                            })
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div></div> <i className="icon-user icons"></i> Customer{" "}
                                    </a>
                                </li>
                            )}
                            {(this.props.rights.permissions.employeeDetails.web.view || this.props.rights.permissions.roleManagement.web.view) && (
                                <li>
                                    <a
                                        style={{ cursor: "pointer" }}
                                        id="permission"
                                        className="prod changeselecteds"
                                        role="button"
                                        onClick={e => {
                                            this.toggleOpen("employee")
                                        }}
                                    >
                                        <div></div> <i className="icon-flag icons"></i> Permissions{" "}
                                    </a>
                                </li>
                            )}

                            {toggle.employee && (
                                <ul className="product-sub-nav">
                                    {this.props.rights.permissions.employeeDetails.web.view && (
                                        <li>
                                            <a
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "EMPLOYEE",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div></div> Employee Details{" "}
                                            </a>
                                        </li>
                                    )}
                                    {this.props.rights.permissions.roleManagement.web.view && (
                                        <li>
                                            <a
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    this.confirmLeavePage({
                                                        nextAction: () => {
                                                            this.props.history.push("/list", {
                                                                moduleName: "ROLE",
                                                                type: "list"
                                                            })
                                                        }
                                                    })
                                                }}
                                            >
                                                <div></div> Role Management{" "}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            )}
                            {(reportRights) && (
                                <li>
                                    <a
                                        style={{ cursor: "pointer" }}
                                        className="changeselecteds"
                                        onClick={() => {
                                            this.confirmLeavePage({
                                                nextAction: () => {
                                                    this.props.history.push("/Report")
                                                }
                                            })
                                        }}
                                    >
                                        <div></div> <i className="fa fa-file-excel-o"></i> Reports{" "}
                                    </a>
                                </li>
                            )}

                        </ul>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        toggle: state.Header.toggle,
        rights: state.main.rights
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            ToggleChange: ToggleChange
        },
        dispatch
    )
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Sidebar)
)


// WEBPACK FOOTER //
// ./src/components/mainLayout/sidebar/component.js